/* eslint-disable */
import PriceType from '../cart/priceType.js';

let FirebaseProductDetail = function(product, currencyFormatter, currencyCode, countryCode){
    let name;
    let sku;
    let shortDescription;
    let longDescription;
    let image;
    let fullImage;
    let size;
    let nettoWeight;

    let isOrder;
    let isAdr;

    let isCustomer;
    let isPreferred;
    let isDistributor;

    let isPurchaseable;
    let isPurchaseableForLTO;
    let hasOrderOption;
    let hasAdrOption;
    let hasRetailSavings;
    let hasWholesaleSavings;
    let showPricing;
    let showAdrPricing;
    let priceClass;

    let pricing = {
        adr:
        {
            retail: "---",
            retailSavings: "---",
            preferred: "---",
            preferredSavings: "---",
            wholesale: "---",
            wholesaleSavings: "---"
        },
        store:
        {
            retail: "---",
            retailSavings: "---",
            preferred: "---",
            preferredSavings: "---"
        },
        web:
        {
            retail: "---",
            preferred: "---",
            wholesale: "---"
        },
        pointsValue:
        {
            pv: "---",
            cv: "---",
            points: "---"
        }
    };

    if (product && product !== null) {
        name = product.getTitle();
        sku = product.sku;
        shortDescription = product.getShortDescr();
        longDescription = product.getLongDescr();
        image = product.getThumbnail().replace('.img.64.64.png', '');
        fullImage = product.getFullImage();
        size = product.getSize();
        nettoWeight = '';

        isOrder = product.orderTypes.contains('order');
        isAdr = product.orderTypes.contains('adr');

        isCustomer = product.isCustomer();
        isPreferred = product.isPreferredCustomer();
        isDistributor = product.isDistributor();

        isPurchaseable = product.available;
        isPurchaseableForLTO = true;
        hasOrderOption = product.hasOrderOption();
        hasAdrOption = product.hasAdrOption();
        hasRetailSavings = true;
        hasWholesaleSavings = true;
        showPricing = true;
        showAdrPricing = true;
        priceClass = '';

        pricing.adr.retail = formatPrice(product.getPricing(PriceType.WADR));
        pricing.adr.retailSavings = formatPrice(product.getPricing(PriceType.WRTL) - product.getPricing(PriceType.WADR));
        pricing.adr.preferred = formatPrice(product.getPricing(PriceType.WADW));
        pricing.adr.preferredSavings;
        pricing.adr.wholesale = formatPrice(product.getPricing(PriceType.WADW));
        pricing.adr.wholesaleSavings = formatPrice(product.getPricing(PriceType.WWHL) - product.getPricing(PriceType.WADW));

        pricing.store.retail;
        pricing.store.retailSavings;
        pricing.store.preferred;
        pricing.store.preferredSavings;

        pricing.web.retail =   formatPrice(product.getPricing(PriceType.WRTL));
        pricing.web.preferred = formatPrice(product.getPricing(PriceType.WWHL));
        pricing.web.wholesale = formatPrice(product.getPricing(PriceType.WWHL));

        pricing.pointsValue.pv = product.getPv();
        pricing.pointsValue.cv = product.getCv();
        pricing.pointsValue.points;
    }

    function formatPrice(amount) {
        return currencyFormatter.format(currencyCode, countryCode, amount);
    }

    // ---------------------------------------------
    //
    //        Public Getter / Setter Methods
    //
    // ---------------------------------------------
    Object.defineProperties(this, {
        pricing: {
            get: function () {
                return pricing;
            },
            set: function (_pricing) {
                pricing = _pricing;
            }
        },
        name: {
            get: function () {
                return name;
            },
            set: function (_name) {
                name = _name;
            }
        },
        sku: {
            get: function () {
                return sku;
            },
            set: function (_sku) {
                sku = _sku;
            }
        },
        shortDescription: {
            get: function () {
                return shortDescription;
            },
            set: function (_shortDescription) {
                shortDescription = _shortDescription;
            }
        },
        longDescription: {
            get: function () {
                return longDescription;
            },
            set: function (_longDescription) {
                longDescription = _longDescription;
            }
        },
        image: {
            get: function () {
                return image;
            },
            set: function (_image) {
                image = _image;
            }
        },
        fullImage: {
            get: function () {
                return fullImage;
            },
            set: function (_fullImage) {
                fullImage = _fullImage;
            }
        },
        size: {
            get: function () {
                return size;
            },
            set: function (_size) {
                size = _size;
            }
        },

        // Order Type
        isOrder: {
            get: function () {
                return isOrder;
            },
            set: function (_isOrder) {
                isOrder = _isOrder;
            }
        },
        isAdr: {
            get: function () {
                return isAdr;
            },
            set: function (_isAdr) {
                isAdr = _isAdr;
            }
        },

        // Customer Type
        isCustomer: {
            get: function () {
                return isCustomer;
            },
            set: function (_isCustomer) {
                isCustomer = _isCustomer;
            }
        },
        isPreferred: {
            get: function () {
                return isPreferred;
            },
            set: function (_isPreferred) {
                isPreferred = _isPreferred;
            }
        },
        isDistributor: {
            get: function () {
                return isDistributor;
            },
            set: function (_isDistributor) {
                isDistributor = _isDistributor;
            }
        },

        // Status
        isPurchaseable: {
            get: function () {
                if(isPurchaseable == "undefined") {
                    isPurchaseable = false;
                }
                return isPurchaseable;
            },
            set: function (_isPurchaseable) {
                isPurchaseable = _isPurchaseable;
            }
        },
        isPurchaseableForLTO: {
            get: function () {
                return isPurchaseableForLTO;
            },
            set: function (_isPurchaseableForLTO) {
                isPurchaseableForLTO = _isPurchaseableForLTO;
            }
        },
        hasOrderOption: {
            get: function () {
                return hasOrderOption;
            },
            set: function (_hasOrderOption) {
                hasOrderOption = _hasOrderOption;
            }
        },
        hasAdrOption: {
            get: function () {
                return hasAdrOption;
            },
            set: function (_hasAdrOption) {
                hasAdrOption = _hasAdrOption;
            }
        },
        hasRetailSavings: {
            get: function () {
                return hasRetailSavings;
            },
            set: function (_hasRetailSavings) {
                hasRetailSavings = _hasRetailSavings;
            }
        },
        hasWholesaleSavings: {
            get: function () {
                return hasWholesaleSavings;
            },
            set: function (_hasWholesaleSavings) {
                hasWholesaleSavings = _hasWholesaleSavings;
            }
        },
        showPricing: {
            get: function () {
                return showPricing;
            },
            set: function (_showPricing) {
                showPricing = _showPricing;
            }
        },
        showAdrPricing: {
            get: function () {
                return showAdrPricing;
            },
            set: function (_showAdrPricing) {
                showAdrPricing = _showAdrPricing;
            }
        },
        priceClass: {
            get: function () {
                return priceClass;
            },
            set: function (_priceClass) {
                priceClass = _priceClass;
            }
        }
    });
};

nuskin.newShop.FirebaseProductDetail = FirebaseProductDetail;

export default FirebaseProductDetail;
